import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import ReactSelect, {createFilter} from 'react-select';
import { selectStyles } from '../../config/constants';
import { useSelector } from 'react-redux';
import SlideDrawer from '../../sharedComponents/SlideDrawer/SlideDrawer';
import { FaArrowLeft, FaChartLine } from 'react-icons/fa6';
import { ValueContainer, DropdownIndicator } from '../../config/customSelect';
import { InputLabel } from '@mui/material';
import ItemScoreViewsCard from './ItemScoreViewsCard/ItemScoreViewsCard';
import itemScoreApi from '../../api/itemScoreApi';
import LocalStorage from '../../sharedComponents/LocalStorage/LocalStorage';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import PageHeader from '../../sharedComponents/Header/PageHeader';
import MobileMenuSlideDrawer from '../../sharedComponents/SlideDrawer/MobileMenuSlideDrawer';
import useManufacturerData from "../../sharedComponents/useManufacturerData/useManufacturerData";
import ManufacturerSelect from "../../sharedComponents/ManufacturerSelect/ManufacturerSelect";

const ItemScore = () => {
  const slideDrawerContents = useSelector(({dashboard}) => dashboard.slideDrawer);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [showProductSelect, setShowProductSelect] = useState(false);
  const [showCategorySelect, setShowCategorySelect] = useState(true);
  const [overviewData, setOverviewData] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const mfrId = LocalStorage.manufacturerData.get().platform_id;
  const { selectedManufacturersValues } = useManufacturerData();

  const requestReport = () => {
    if (overviewData?.ownProducts?.length) {
      const top5TableData = overviewData.ownProducts.slice(0, 5);
      const worksheet = XLSX.utils.json_to_sheet(top5TableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Item Performance List');
      const date = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
      XLSX.writeFile(workbook, `SalesStream_ItemScore_ItemPerformanceList_${date}.xlsx`);
    } else {
      toast.error('No data available to export.');
    }
  };

  const handleClickReturn = () => {
    setRefresh(refresh + 1);
  };

  useEffect(() => {
    const params = {
      platformIds: selectedManufacturersValues?.length > 0 ? selectedManufacturersValues : [mfrId],
    };

    itemScoreApi.postCategoryIds.post(params).then(response => {
      if(response.status === 200) {
        const formattedOptions = response.data?.map((category) => ({'label': category.name, 'value': category.category_id}));
        setCategories(formattedOptions);
        setSelectedCategory(formattedOptions[0]);
      }
    }).catch(err => {
      console.error(err);
      toast.error('Something went wrong loading categories');
    })
    // eslint-disable-next-line
  }, [selectedManufacturersValues]);

  useEffect(() => {
      if (selectedCategory) {
          setOverviewData([]);
          var params = {
              platformId: selectedManufacturersValues?.length > 0 ? selectedManufacturersValues : [mfrId],
              categoryId: selectedCategory.value
          };
          itemScoreApi.getOverview.post(params).then(response => {
              if(response.status === 200) {
                  setOverviewData(response.data);
                  const productsData = response.data?.ownProducts?.map((product) => {return {label: product.description.toLowerCase(), value: product.product_id}});
                  setProducts(productsData);
              }
          }).catch(err => {
              console.log(err);
              toast.error('Something went wrong fetching overview data.');
          })
      }
      // eslint-disable-next-line
  }, [selectedCategory]);

  return (
    <>
      <PageHeader title='SalesStream' subtitle="Item Score" icon={<FaChartLine fill='url(#icon-gradient)'/>}/>
      <Col className='p-3'>
        {showProductSelect &&
        <>
          <Row className='ps-0 d-flex justify-content-between align-items-end' >
              <Col className='w-fc'>
                <Button
                className='py-0 button-label px-3 py-1'
                style={{color: 'white'}}
                size='sm'
                color={'blueFilter'}
                onClick={() => handleClickReturn()}><FaArrowLeft style={{position: 'relative', bottom: '1px'}} /> Back to Item Scores
                </Button>
              </Col>
          </Row>
          <hr className='line' style={{border: '1px solid grey'}}></hr>
        </>
        }
        <Row className='label-text text-size-14 d-flex align-items-center mx-auto pb-2'>
            <Col className='col-3 ps-1'>
              <ManufacturerSelect align="start" />
            </Col>
            {showCategorySelect &&
            <Col className='col-3 ps-1' style={{minWidth: '200px', whiteSpace: 'nowrap'}}>
              <InputLabel style={{color: 'black', fontSize: '12px'}}>Category</InputLabel>
              <ReactSelect
                  captureMenuScroll={false}
                  classNamePrefix="custom-select "
                  filterOption={createFilter({ ignoreAccents: false })}
                  hideSelectedOptions={false}
                  name='category'
                  styles={selectStyles}
                  components={{ ValueContainer, DropdownIndicator }}
                  options = {categories}
                  onChange = {(e) => setSelectedCategory(e)}
                  value = {selectedCategory}
                  placeholder='Select Category'
              />
            </Col>
            }
            {showProductSelect &&
            <Col className='col-3 ps-1' style={{textTransform: 'capitalize', minWidth: '200px', whiteSpace: 'nowrap'}}>
              <InputLabel style={{color: 'black', fontSize: '12px'}}>Products</InputLabel>
              <ReactSelect
                  captureMenuScroll={false}
                  classNamePrefix="custom-select "
                  filterOption={createFilter({ ignoreAccents: false })}
                  hideSelectedOptions={false}
                  name='product'
                  styles={selectStyles}
                  components={{ ValueContainer, DropdownIndicator }}
                  options = {products}
                  onChange = {(e) => setSelectedProduct(e)}
                  value = {selectedProduct}
                  placeholder='Select Product'
              />
            </Col>
            }
            <Col></Col>
            {!showProductSelect &&
            <Col className='pt-4 w-fc px-0'>
              <Button
                  outline
                  className='py-2 px-4'
                  size='sm'
                  style={{width: '124px'}}
                  onClick={() => requestReport()}
                  color={'blueFilter'}>Export All
              </Button>
            </Col>
            }

        </Row>
        <ItemScoreViewsCard refresh={refresh} selectedCategory={selectedCategory} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} setShowCategorySelect={setShowCategorySelect} setShowProductSelect={setShowProductSelect} overviewData={overviewData}/>
        <SlideDrawer title={slideDrawerContents.title} drawerContents={slideDrawerContents.contents}/>
        <MobileMenuSlideDrawer />
      </Col>
    </>
  );
}

export default ItemScore;
